import { isPlatformBrowser } from '@angular/common';
import { Injectable, inject, PLATFORM_ID, signal } from '@angular/core';
import * as microsoftTeams from '@microsoft/teams-js';

@Injectable({
  providedIn: 'root',
})
export class MicrosoftTeamsIntegrationService {
  private readonly platformId = inject(PLATFORM_ID);

  readonly isInitializing = signal<boolean>(true);
  readonly isMicrosoftTeamsEnvironment = signal<boolean>(false);

  constructor() {
    this.checkTeamsEnvironment().then(() => {
      console.info(`Running app in Microsoft Teams environment: ${this.isMicrosoftTeamsEnvironment()}`);
      this.isInitializing.set(false);
    });
  }

  private async checkTeamsEnvironment() {
    if (!isPlatformBrowser(this.platformId)) return;

    try {
      await microsoftTeams.app.initialize();
      await microsoftTeams.app.notifySuccess();
      this.isMicrosoftTeamsEnvironment.set(true);
    } catch (error) {
      if (
        this.isInitializing() &&
        error instanceof Error &&
        error.message.includes('Initialization Failed. No Parent window found.')
      ) {
        console.info('No Teams Environment detected');
      } else {
        console.error('Error initializing Microsoft Teams environment', error);
      }
      this.isMicrosoftTeamsEnvironment.set(false);
    }
  }

  getToken(): Promise<string> {
    return microsoftTeams.authentication.getAuthToken();
  }

  joinMeeting(meetingUrl: string) {
    console.info('Using Microsoft Teams SDK to join meeting');
    microsoftTeams.meeting.joinMeeting({
      joinWebUrl: new URL(meetingUrl),
    });
  }
}
